import EzController from 'controllers/ez-base-controller';
import { saveToLocalAndCookie } from 'lib/sessions-manager';

export default class ResourceShowMainController extends EzController {
  connect() {
    saveToLocalAndCookie('most_recent_resource_id',
      this.element.dataset.resourceId);

    if (this.element.dataset.autodlPath) {
      this.triggerResourceDownload();
    }
  }

  triggerResourceDownload() {
    window.location = this.element.dataset.autodlPath;
  }
}
